import { useTranslation } from 'react-i18next';

import { ConfirmAction } from '../Modal/ConfirmAction';

interface PropTypes {
  onSave: () => Promise<any>;
  connection: any;
}

const DisconnectDevice: React.FC<PropTypes> = ({ onSave, connection }) => {
  const { t } = useTranslation();

  return (
    <ConfirmAction
      title={t('modals.disconnectDevice.title', {
        deviceName: connection.deviceName
      })}
      confirmedTitle={t('modals.disconnectDevice.confirmedTitle', { deviceName: connection.deviceName })}
      saveButtonName={t('modals.disconnectDevice.agree')}
      save={onSave}
    />
  );
};

export default DisconnectDevice;
